module.exports = __webpack_public_path__ + "img/bingo_ball-30.f59a2e0c.png";